import { Bell } from "lucide-react";
import { Phone, seg } from "./primitives";

const DAYS = ["Initial response", "Follow-up message", "Additional follow-up", "Reminder", "Personalized follow-up", "Check-in", "Final follow-up"];
const SMS = "Hey John! Thanks for reaching out about your home's value. We'd love to help. When would be a good time to give you a call?";

export function StageFollowUp({ p }) {
  const notif = seg(p, 0.05, 0.15);
  const typed = Math.round(seg(p, 0.25, 0.5) * SMS.length);
  const daysLit = Math.floor(seg(p, 0.5, 0.95) * 7);
  return (
    <div className="flex h-full w-full items-center justify-center gap-3 sm:gap-8">
      <Phone className="h-full shrink-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d1b33] via-[#0B0D13] to-[#0B0D13] px-3 pt-10">
          <p className="text-center text-4xl font-light tracking-tight text-white">9:41</p>
          <p className="text-center text-[10px] text-slate-400">Tuesday, October 6</p>
          <div className="mt-4 rounded-2xl bg-white/90 p-2.5 text-slate-900 shadow-xl" style={{ opacity: notif, transform: `translateY(${(1 - notif) * -30}px)` }} data-testid="process-lead-notification">
            <div className="flex items-center gap-1.5 text-[9px] font-semibold uppercase text-slate-500"><Bell className="h-3 w-3 text-electric" /> Rivanta Leads · now</div>
            <p className="mt-1 text-[11px] font-bold">New Lead Received</p>
            <p className="text-[10px] leading-snug">Name: John Smith<br />Interested in: Home Valuation<br />Phone: (406) 555-0123</p>
          </div>
          <div className="mt-3 space-y-1.5" style={{ opacity: seg(p, 0.2, 0.26) }}>
            <p className="text-center text-[9px] text-slate-400">Automated text · sent to John</p>
            <div className="ml-auto max-w-[88%] rounded-2xl rounded-br-md bg-electric px-3 py-2 text-[10.5px] leading-snug text-white">
              {SMS.slice(0, typed)}{typed < SMS.length && <span className="ml-0.5 inline-block h-2.5 w-[2px] animate-blink bg-white" />}
            </div>
            <div className="max-w-[60%] rounded-2xl rounded-bl-md bg-white/10 px-3 py-2 text-[10.5px] text-white" style={{ opacity: seg(p, 0.55, 0.62) }}>
              Tomorrow after 3 works!
            </div>
          </div>
        </div>
      </Phone>
      <ol className="flex flex-col gap-1.5 sm:hidden" aria-label="7-day follow-up">
        {DAYS.map((d, i) => (
          <li key={d} className={`rounded-md border px-2 py-1 font-mono text-[10px] ${i < daysLit || (i === 0 && p > 0.3) ? "border-cyan-300/60 text-white" : "border-white/10 text-slate-500"}`}>Day {i + 1}</li>
        ))}
      </ol>
      <div className="hidden w-[46%] sm:block">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">7-day follow-up sequence</p>
        <ol className="relative mt-4 space-y-2.5 border-l border-white/10 pl-5">
          {DAYS.map((d, i) => {
            const lit = i < daysLit || (i === 0 && p > 0.3);
            return (
              <li key={d} className="relative">
                <span className={`absolute -left-[26px] top-1 h-2.5 w-2.5 rounded-full transition-colors duration-300 ${lit ? "bg-cyan-300 shadow-[0_0_12px_#00E5FF]" : "bg-white/15"}`} />
                <p className={`text-[13px] transition-colors duration-300 ${lit ? "text-white" : "text-slate-500"}`}><span className="font-mono text-[11px] text-slate-400">Day {i + 1}</span> · {d}</p>
              </li>
            );
          })}
        </ol>
        <p className="mt-4 text-[11px] leading-relaxed text-slate-400">Only sent to leads who have provided any required consent. Opt-outs are honored automatically.</p>
      </div>
    </div>
  );
}
